import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import React, { useMemo } from 'react';
import { generateCellKey, renderCell, transformCardItems } from '@/modules/expense-reports/lib/advanced-inner-table-helpers';
import { DEFAULT_COLUMN_WIDTH, DEFAULT_MIN_WIDTH } from '@/modules/expense-reports/lib/constants';
import type { AdvancedInnerTableProps, Alignment } from '@/modules/expense-reports/types';
import { EmptyTablePlaceholder } from './empty-table-placeholder';
import { TransparencyCard } from './transparency-card/transparency-card';
function AdvancedInnerTable(t0) {
  const $ = _c(17);
  const {
    cardsTotalPosition: t1,
    columns,
    items,
    longCode,
    style,
    className,
    tablePlaceholder,
    cardSpacingSize: t2
  } = t0;
  const cardsTotalPosition = t1 === undefined ? "bottom" : t1;
  const cardSpacingSize = t2 === undefined ? "large" : t2;
  let t3;
  if ($[0] !== columns) {
    t3 = columns.filter(_temp);
    $[0] = columns;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const visibleColumns = t3;
  let t4;
  if ($[2] !== cardsTotalPosition || $[3] !== items) {
    t4 = transformCardItems(items, cardsTotalPosition);
    $[2] = cardsTotalPosition;
    $[3] = items;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const cardItems = t4;
  let t5;
  if ($[5] !== columns) {
    t5 = columns.filter(_temp2);
    $[5] = columns;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const cardHeaderColumns = t5;
  const getRenderedCell = _temp3;
  let t6;
  if ($[7] !== cardHeaderColumns || $[8] !== cardItems || $[9] !== cardSpacingSize || $[10] !== className || $[11] !== items || $[12] !== longCode || $[13] !== style || $[14] !== tablePlaceholder || $[15] !== visibleColumns) {
    t6 = items.length > 0 ? <><div className="hidden overflow-hidden rounded-xl shadow-xs md:block"><div style={style} className={cn("bg-popover scrollbar-thin overflow-x-auto", className)}><table className="w-full flex-1 border-collapse"><thead className="text-semibold border-b text-xs/4.5 whitespace-nowrap"><tr>{visibleColumns.map(_temp4)}</tr></thead><tbody>{items.map((row, rowIndex_0) => {
                const visibleRowItems = row.items.filter(_temp5);
                return <tr key={`row-${rowIndex_0}`} className={cn({
                  "border-t": row.borderTop ?? row.type === "total",
                  "not-last-of-type:border-b": row.borderBottom
                })}>{visibleRowItems.map((item, columnIndex_1) => <td key={`row-${rowIndex_0}-column-${columnIndex_1}`} colSpan={row.type === "groupTitle" || row.type === "section" ? 3 : undefined} className={cn({
                    "border-r": item.column.hasBorderRight,
                    "text-left": item.column.align === "left",
                    "text-center": item.column.align === "center",
                    "text-right": item.column.align === "right"
                  }, item.column.className)}>{getRenderedCell(item.column, row.type, item.value, rowIndex_0, columnIndex_1)}</td>)}</tr>;
              })}</tbody></table></div></div><div className={cn("flex flex-col gap-4 md:hidden", "[&_.advance-table--transparency\\_item_.advance-table--transparency-card\\_icon\\_hidden]:hidden")}>{cardItems.map((item_0, cardIndex) => {
          if (item_0.type === "groupTitle") {
            return null;
          }
          const cardHeaderItems = item_0.items.filter(_temp6);
          const cardBodyItems = item_0.items.filter(_temp7);
          const cardFooterItems = item_0.items.filter(_temp8);
          const separatorItems = item_0.items.filter(_temp9);
          return <TransparencyCard category={item_0.category} showSubHeader={item_0.showHeader ?? false} itemType={item_0.type} subHeader={item_0.subHeader ?? ""} key={`item-${cardIndex}`} cardSpacingSize={cardSpacingSize} separators={separatorItems.map(_temp10)} header={<>{cardHeaderItems.map((x_7, headerIndex) => getRenderedCell(x_7.column, item_0.type, x_7.value, cardIndex, headerIndex))}</>} headers={cardHeaderColumns.map(_temp11)} items={cardBodyItems.map((x_9, bodyIndex) => getRenderedCell(x_9.column, item_0.type, x_9.value, cardIndex, bodyIndex)) as React.ReactElement[]} footer={cardFooterItems.length > 0 ? <>{cardFooterItems.map((x_10, footerIndex) => getRenderedCell(x_10.column, "normal", x_10.value, cardIndex, footerIndex))}</> : undefined} />;
        })}</div></> : tablePlaceholder ?? <EmptyTablePlaceholder actorName={longCode} />;
    $[7] = cardHeaderColumns;
    $[8] = cardItems;
    $[9] = cardSpacingSize;
    $[10] = className;
    $[11] = items;
    $[12] = longCode;
    $[13] = style;
    $[14] = tablePlaceholder;
    $[15] = visibleColumns;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp11(x_8) {
  return x_8.header;
}
function _temp10(x_6) {
  return !!x_6.column.hasBorderBottomOnCard;
}
function _temp9(x_5) {
  return !x_5.column.hidden && !x_5.column.isCardHeader && !x_5.column.isCardFooter;
}
function _temp8(x_4) {
  return x_4.column.isCardFooter;
}
function _temp7(x_3) {
  return !x_3.column.hidden && !x_3.column.isCardFooter && !x_3.column.isCardHeader;
}
function _temp6(x_2) {
  return x_2.column.isCardHeader && x_2.value && !x_2.column.hidden;
}
function _temp5(x_1) {
  return !x_1.column.hidden;
}
function _temp4(column_0, columnIndex_0) {
  return <th key={`header-${columnIndex_0}`} className={cn("text-foreground/50 overflow-hidden px-2 py-2 text-base/6 font-semibold lg:px-4", {
    "border-r": column_0.hasBorderRight
  }, column_0.className)} style={{
    textAlign: (column_0.headerAlign ?? column_0.align ?? "left") as Alignment,
    width: column_0.width ?? DEFAULT_COLUMN_WIDTH,
    minWidth: column_0.minWidth ?? DEFAULT_MIN_WIDTH
  }}>{column_0.header}</th>;
}
function _temp3(column, rowType, value, rowIndex, columnIndex) {
  const cellKey = generateCellKey(rowIndex, columnIndex);
  return renderCell(column, rowType, value, cellKey);
}
function _temp2(x_0) {
  return !x_0.hidden && !x_0.isCardHeader && !x_0.isCardFooter;
}
function _temp(x) {
  return !x.hidden;
}
export { AdvancedInnerTable };